<template lang="pug">

include /mixins
validation-provider(
  v-slot="{ errors, validate }"
  :name='name'
  :bails='false'
  :ref='`${name}_valid`'
  :rules='rules'
)
  div.relative
    input(
      type='hidden',
      :vid='name'
      :name='name'
      :ref='name'
      v-model='value'
    )
    +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}

    resource-loader-controller(
      :resource='$options.fileExtentionResource'
      :immediate='true',
    )
      template(
        #default='{ receive, result, loading }'
      )
        div.relative
          gallery(
            :extentions='result'
            type_name="certificates"
            class="document-files-gallery"
            :submit-on-upload="true"
            :post-resource='$options.createTicketFile',
            :get-resource='retriever()',
            :delete-resource='$options.removeTicketFile',
            :can-delete="canDelete",
            @update="update($event, validate)",
            filekey="file",
            :fields="fields"
            :id='id'
            :can-add='getCanAdd'
            :limit='limit'
          )

</template>

<script>

import {
  createTicketFile, removeTicketFile,
} from '@api/ticket.service'

import {
  fileExtentionResource,
} from '@api/vendor.service'

export default {
  createTicketFile,
  removeTicketFile,
  fileExtentionResource,
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
    value: {
      type: Array,
      default: () => [],
    },
    changed: {
      type: Boolean,
      default: false,
    },
    canAdd: {
      type: Boolean,
      default: true,
    },
    fields: {
      type: Object,
      default: () => ({ colsWrapper: '6', colsAdd: '6', colsGallery: '12', colsFields: 'auto' }),
    },
    name: {
      type: String,
      default: 'files',
    },
    rules: {
      type: Object,
    },
    limit: {
      type: Number,
    },
  },
  data() {
    return {
      was: this.value.map(x => x.id),
    }
  },
  computed: {
    getCanAdd() {
      if (this.canAdd === undefined) {
        return this.value.length < this.limit
      }
      return this.canAdd
    },
  },
  created() {
    this.$emit('files:count', this.value.length)
  },
  methods: {
    retriever() {
      return {
        execute: () => new Promise(
          resolve => resolve({ data: { items: [...this.value] } })
        ),
      }
    },
    canDelete(item) {
      return !!this.changed && !this.was.includes(item.id)
    },
    update($event, validate) {
      console.log(this.$refs);
      this.$emit('update', $event)
      this.$nextTick(() => {
        this.$refs[this.name].value = $event[0] && $event[0].file ? $event[0].file : $event
        this.$refs[`${this.name}_valid`].setErrors([])
        validate()
      })
    },
  },
}

</script>

<style>
.document-files-gallery,
.document-files-gallery > .ds-panel__element {
  margin: 0;
}
</style>
